"use client"
import { CartItem } from "@/components/main/cart/CartItem"
import { useAuth } from "@/contexts/authContext"
import { useCartStore } from "@/core/hooks/cart/useCartStore"

export default function Page() {
    const { cart } = useCartStore()
    const { updateCartItem, removeFromCart } = useCartStore()
    const {
        state: { isAuthenticated },
    } = useAuth();


    const handleUpdateQuantity = (productId: number, quantity: number) => {
        updateCartItem(productId, quantity, isAuthenticated)

    }

    const handleRemoveItem = (productId: number) => {
        removeFromCart(productId, isAuthenticated)
    }

    return (
        <div>





            <div className="space-y-4 mb-8">
                {cart.items.map((item) => (
                    <CartItem
                        key={item.product_id}
                        item={item}
                        onUpdateQuantity={handleUpdateQuantity}
                        onRemove={handleRemoveItem}
                    />
                ))}
            </div>
        </div>
    )
}